<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="part-1-early-years">
<h1 style="padding-top:250px; font-family:Arial;">Part 1: Early Years</h1>
<p style="text-align: center;"><em>Life does not owe you anything</em>,</p>
<p style="text-align: center;"><em>because life has already given you everything.</em></p>
<p style="text-align: right;"><strong><em>Mark Twain</em></strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?563f3f3a